export const CanvasShapeEnum = {
    Square: 'SQUARE',
    SquareWithArrow: 'SQARE_WITH_ARROW',
    Circle: 'CIRCLE',
    Triangle: 'TRIANGLE',
    SpiderCircle: 'SPIDER_CIRCLE'
};
